import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import Auth from "auth"
import AuthRoutes from "routes/auth.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components

import PagesNoLayoutRoutes from "routes/pagesNoLayout.jsx";

import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "assets/img/wallpaper-r1.png";
// import bgImage from "assets/img/bg_mocap_survey.jpg";
// import bgImage from "assets/img/background.jpg";
const styles = {
  ... pagesStyle,
  inFullPage:{
    minHeight: "100vh",
    color: "#fff !important",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100%",
  }
}
class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }
  render() {
    const { classes } = this.props;
    return (
        // <div className={classes.wrapper} ref="wrapper">
        // <div className={classes.wrapper}>
          // <div
          //   className={classes.inFullPage+" survey-bg"}
          //   style={{ backgroundImage: "url(" + bgImage + ")" }}
          // >
            <Switch> 
              {PagesNoLayoutRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                if (prop.forGuest && Auth.isAuthentication()) {
                  const user_type_code = Auth.getUserData().user_type_code 
                  if(AuthRoutes[user_type_code] != undefined){
                    return (
                      <Redirect from={prop.path} to={AuthRoutes[user_type_code].forNoGuest} key={key} />
                    );
                  }else{
                    return (
                      <Redirect from={prop.path} to={AuthRoutes.default.forNoGuest} key={key} />
                    );
                  }
                }
                if (prop.forLogin && !Auth.isAuthentication()) {
                  return (
                    <Redirect from={prop.path} to={AuthRoutes.default.forNoLogin} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          // </div>
        // </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Pages);
